export default "__VITE_ASSET__C2eE2JQ6__"